import React from 'react';
import { Gift, Check, MessageSquare, MapPin, ClipboardList } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { trackAddToCart } from '../utils/metaPixel';
export function BonusStack() {
  return <section className="py-24 md:py-32 bg-offwhite-dark relative overflow-hidden" data-id="element-15">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl" data-id="element-16">
        {/* CTA Button */}
        <FadeIn data-id="element-17">
          <div id="quiero-todo" className="text-center mb-16" data-id="element-18">
            <a href="#proteger-ahora" className="inline-flex items-center justify-center w-full md:w-auto px-8 py-4 bg-amber hover:bg-amber-light text-navy font-bold rounded-lg transition-all duration-300 shadow-lg text-lg transform hover:-translate-y-1" data-id="element-19">
              QUIERO TODO ESTO PARA MI HIJO + BONUS EXCLUSIVOS
            </a>
          </div>
        </FadeIn>

        {/* Intro Section */}
        <FadeIn data-id="element-20">
          <div className="text-center mb-24" data-id="element-21">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber/20 text-amber-dark font-bold mb-8 border border-amber/30" data-id="element-22">
              <Gift size={18} data-id="element-23" />
              <span data-id="element-24">Bonus Exclusivos</span>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-8 leading-tight max-w-4xl mx-auto" data-id="element-25">
              Todo lo que necesitás para proteger a tu hijo del bullying está
              aquí. Y los 3 bonus que lo hacen posible desde mañana…{' '}
              <span className="text-amber-dark" data-id="element-26">son completamente gratis.</span>
            </h2>

            <p className="text-xl md:text-2xl text-navy/80 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-27">
              Cuando comprás <strong data-id="element-28">Escudo de Confianza</strong> hoy, recibís 3
              recursos adicionales valuados en <strong data-id="element-29">$47.00 USD</strong> sin
              costo adicional. Solo por esta página y solo por tiempo limitado.
            </p>

            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-navy/5 text-left max-w-4xl mx-auto" data-id="element-30">
              <p className="text-lg md:text-xl text-navy/80 leading-relaxed mb-6" data-id="element-31">
                Imaginá esto:
              </p>
              <p className="text-lg md:text-xl text-navy/80 leading-relaxed mb-6" data-id="element-32">
                Tu hijo sale mañana de casa con <strong data-id="element-33">5 frases listas</strong>{' '}
                en la cabeza para neutralizar cualquier burla sin pelear y sin
                llorar. Sabe exactamente <strong data-id="element-34">a dónde ir</strong> si algo
                pasa en el recreo. Y vos llegás a la reunión del colegio con un{' '}
                <strong data-id="element-35">guion claro</strong> para salir con medidas concretas,
                no con promesas vacías.
              </p>
              <p className="text-lg md:text-xl text-navy/80 leading-relaxed mb-8" data-id="element-36">
                Eso no es un sueño. Es exactamente lo que van a tener cuando se
                lleven el paquete completo hoy.
              </p>
              <div className="h-px w-full bg-navy/10 mb-8" data-id="element-37"></div>
              <p className="text-lg md:text-xl text-navy/80 leading-relaxed" data-id="element-38">
                El <strong data-id="element-39">Escudo de Confianza</strong> ya te da el método
                completo. Pero hay 3 piezas que aceleran todo desde el día 1.
                Tres recursos que desarrollé específicamente para que no pierdas
                ni un día más esperando que las cosas "se solucionen solas". Hoy
                son tuyos sin costo adicional.
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Bonus 1 */}
        <FadeIn delay={0.1} data-id="element-40">
          <div className="bg-white rounded-[2.5rem] p-8 md:p-12 shadow-xl border border-navy/5 mb-16 relative overflow-hidden" data-id="element-41">
            <div className="absolute top-0 right-0 w-64 h-64 bg-teal/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-42"></div>

            <div className="grid lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-43">
              <div className="order-2 lg:order-1" data-id="element-44">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal/10 text-teal font-bold mb-6" data-id="element-45">
                  <Gift size={16} data-id="element-46" />
                  <span data-id="element-47">BONUS #1</span>
                </div>

                <h3 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-2" data-id="element-48">
                  Kit de Frases CERO PÁNICO
                </h3>
                <p className="text-xl text-navy/60 mb-6" data-id="element-49">
                  Tarjetas de bolsillo + práctica rápida (8–12 años)
                </p>

                <div className="bg-amber/10 border border-amber/20 rounded-xl p-4 mb-8 inline-block" data-id="element-50">
                  <p className="text-navy font-medium" data-id="element-51">
                    Valor real:{' '}
                    <span className="line-through text-navy/50" data-id="element-52">
                      $17.00 USD
                    </span>{' '}
                    —{' '}
                    <span className="text-amber-dark font-bold" data-id="element-53">
                      Hoy: GRATIS
                    </span>
                  </p>
                </div>

                <p className="text-lg text-navy/80 mb-6 leading-relaxed" data-id="element-54">
                  ¿Sabés cuál es el momento más aterrador para un niño acosado?
                  No es el insulto. Es el{' '}
                  <strong data-id="element-55">silencio que viene después</strong>. Ese segundo y
                  medio donde su mente se congela, no sabe qué decir y el
                  acosador lo lee como miedo. Este kit elimina ese silencio para
                  siempre.
                </p>

                <p className="text-lg text-navy/80 mb-4 font-medium" data-id="element-56">
                  Tu hijo va a tener 30 frases exactas organizadas en 3
                  categorías:
                </p>

                <ul className="space-y-3 mb-8" data-id="element-57">
                  <li className="flex items-start gap-3" data-id="element-58">
                    <Check className="text-teal flex-shrink-0 mt-1" size={20} data-id="element-59" />
                    <span className="text-navy/80" data-id="element-60">
                      <strong data-id="element-61">10 frases para Neutralizar</strong> (cuando lo
                      insultan o burlan)
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-62">
                    <Check className="text-teal flex-shrink-0 mt-1" size={20} data-id="element-63" />
                    <span className="text-navy/80" data-id="element-64">
                      <strong data-id="element-65">10 frases para Cortar y Salir</strong> (cuando lo
                      siguen o rodean)
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-66">
                    <Check className="text-teal flex-shrink-0 mt-1" size={20} data-id="element-67" />
                    <span className="text-navy/80" data-id="element-68">
                      <strong data-id="element-69">10 frases para Avisar</strong> (cómo pedir ayuda
                      sin sentirse "chivato")
                    </span>
                  </li>
                </ul>

                <div className="bg-offwhite p-6 rounded-2xl border border-navy/5 mb-8" data-id="element-70">
                  <p className="text-sm font-bold text-navy/60 uppercase tracking-wider mb-3" data-id="element-71">
                    Incluye además:
                  </p>
                  <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 text-navy/80" data-id="element-72">
                    <li className="flex items-center gap-2" data-id="element-73">
                      <div className="w-1.5 h-1.5 rounded-full bg-amber" data-id="element-74"></div>{' '}
                      Tarjetas imprimibles
                    </li>
                    <li className="flex items-center gap-2" data-id="element-75">
                      <div className="w-1.5 h-1.5 rounded-full bg-amber" data-id="element-76"></div>{' '}
                      Versión móvil
                    </li>
                    <li className="flex items-center gap-2" data-id="element-77">
                      <div className="w-1.5 h-1.5 rounded-full bg-amber" data-id="element-78"></div>{' '}
                      Audio-guía (3 min)
                    </li>
                    <li className="flex items-center gap-2" data-id="element-79">
                      <div className="w-1.5 h-1.5 rounded-full bg-amber" data-id="element-80"></div>{' '}
                      Script de roleplay
                    </li>
                  </ul>
                </div>

                <div className="border-l-4 border-teal pl-6 py-2" data-id="element-81">
                  <p className="text-sm font-bold text-navy/60 uppercase tracking-wider mb-2" data-id="element-82">
                    La palabra más poderosa del kit:
                  </p>
                  <p className="text-xl font-serif italic text-navy" data-id="element-83">
                    "Ok." Dicha con calma. Con cara neutra. Y caminando.
                  </p>
                  <p className="text-navy/70 mt-2" data-id="element-84">
                    Es imposible pelear contra un "Ok" aburrido.
                  </p>
                </div>
              </div>

              <div className="order-1 lg:order-2 flex justify-center" data-id="element-85">
                <img src="https://cdn.magicpatterns.com/uploads/23eZbE5abLXmjyF4ei4iqc/Bono_1.png" alt="Kit de Frases Cero Pánico" className="w-full max-w-md rounded-2xl shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-86" />
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Bonus 2 */}
        <FadeIn delay={0.2} data-id="element-87">
          <div className="bg-white rounded-[2.5rem] p-8 md:p-12 shadow-xl border border-navy/5 mb-16 relative overflow-hidden" data-id="element-88">
            <div className="absolute top-0 left-0 w-64 h-64 bg-amber/5 rounded-full blur-3xl -translate-y-1/2 -translate-x-1/2" data-id="element-89"></div>

            <div className="grid lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-90">
              <div className="flex justify-center" data-id="element-91">
                <img src="https://cdn.magicpatterns.com/uploads/nJpuAze7YqNwxxkNej1dri/Bono_2.png" alt="Mapa Zonas Seguras" className="w-full max-w-md rounded-2xl shadow-2xl transform -rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-92" />
              </div>

              <div data-id="element-93">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal/10 text-teal font-bold mb-6" data-id="element-94">
                  <Gift size={16} data-id="element-95" />
                  <span data-id="element-96">BONUS #2</span>
                </div>

                <h3 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-2" data-id="element-97">
                  Mapa ZONAS SEGURAS del Colegio
                </h3>
                <p className="text-xl text-navy/60 mb-6" data-id="element-98">
                  Planner visual + Plan de Recreo (8–12 años)
                </p>

                <div className="bg-amber/10 border border-amber/20 rounded-xl p-4 mb-8 inline-block" data-id="element-99">
                  <p className="text-navy font-medium" data-id="element-100">
                    Valor real:{' '}
                    <span className="line-through text-navy/50" data-id="element-101">
                      $17.00 USD
                    </span>{' '}
                    —{' '}
                    <span className="text-amber-dark font-bold" data-id="element-102">
                      Hoy: GRATIS
                    </span>
                  </p>
                </div>

                <p className="text-lg text-navy/80 mb-6 leading-relaxed" data-id="element-103">
                  Los acosadores no atacan al azar. Atacan en{' '}
                  <strong data-id="element-104">lugares específicos</strong>: detrás del gimnasio, en
                  el baño sin vigilancia, en la esquina del patio donde no hay
                  adultos. Este planner convierte la escuela de una amenaza en
                  un <strong data-id="element-105">mapa de seguridad</strong>.
                </p>

                <p className="text-lg text-navy/80 mb-4 font-medium" data-id="element-106">
                  En 15 minutos, tu hijo va a tener:
                </p>

                <ul className="space-y-3 mb-8" data-id="element-107">
                  <li className="flex items-start gap-3" data-id="element-108">
                    <Check className="text-teal flex-shrink-0 mt-1" size={20} data-id="element-109" />
                    <span className="text-navy/80" data-id="element-110">
                      <strong data-id="element-111">El sistema del Semáforo</strong>: sabe exactamente
                      qué zonas son seguras y cuáles evitar.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-112">
                    <Check className="text-teal flex-shrink-0 mt-1" size={20} data-id="element-113" />
                    <span className="text-navy/80" data-id="element-114">
                      <strong data-id="element-115">Sus "Islas Verdes"</strong>: 3 lugares donde puede
                      refugiarse si algo pasa.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-116">
                    <Check className="text-teal flex-shrink-0 mt-1" size={20} data-id="element-117" />
                    <span className="text-navy/80" data-id="element-118">
                      <strong data-id="element-119">Su Mapa de Aliados</strong>: 3 amigos + 2 adultos
                      de confianza en la escuela.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-120">
                    <Check className="text-teal flex-shrink-0 mt-1" size={20} data-id="element-121" />
                    <span className="text-navy/80" data-id="element-122">
                      <strong data-id="element-123">Plan de Recreo y Pasillos</strong>: qué hacer y
                      las 4 reglas para evitar "emboscadas".
                    </span>
                  </li>
                </ul>

                <div className="bg-offwhite p-6 rounded-2xl border border-navy/5 mb-8" data-id="element-124">
                  <p className="text-sm font-bold text-navy/60 uppercase tracking-wider mb-3" data-id="element-125">
                    Incluye además:
                  </p>
                  <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 text-navy/80" data-id="element-126">
                    <li className="flex items-center gap-2" data-id="element-127">
                      <div className="w-1.5 h-1.5 rounded-full bg-amber" data-id="element-128"></div>{' '}
                      Plantillas imprimibles A4
                    </li>
                    <li className="flex items-center gap-2" data-id="element-129">
                      <div className="w-1.5 h-1.5 rounded-full bg-amber" data-id="element-130"></div>{' '}
                      Checklist mochila
                    </li>
                    <li className="flex items-center gap-2" data-id="element-131">
                      <div className="w-1.5 h-1.5 rounded-full bg-amber" data-id="element-132"></div>{' '}
                      Hoja revisión semanal
                    </li>
                  </ul>
                </div>

                <div className="border-l-4 border-teal pl-6 py-2" data-id="element-133">
                  <p className="text-sm font-bold text-navy/60 uppercase tracking-wider mb-2" data-id="element-134">
                    Lo más importante:
                  </p>
                  <p className="text-xl font-serif italic text-navy" data-id="element-135">
                    Cuando tu hijo tiene un plan, deja de entrar al colegio con
                    miedo. Entra con un mapa.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Bonus 3 */}
        <FadeIn delay={0.3} data-id="element-136">
          <div className="bg-white rounded-[2.5rem] p-8 md:p-12 shadow-xl border border-navy/5 relative overflow-hidden" data-id="element-137">
            <div className="absolute bottom-0 right-0 w-64 h-64 bg-teal/5 rounded-full blur-3xl translate-y-1/2 translate-x-1/2" data-id="element-138"></div>

            <div className="grid lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-139">
              <div className="order-2 lg:order-1" data-id="element-140">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal/10 text-teal font-bold mb-6" data-id="element-141">
                  <Gift size={16} data-id="element-142" />
                  <span data-id="element-143">BONUS #3</span>
                </div>

                <h3 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-2" data-id="element-144">
                  Reunión en 20 Min
                </h3>
                <p className="text-xl text-navy/60 mb-6" data-id="element-145">
                  Checklist + Guion para hablar con la escuela
                </p>

                <div className="bg-amber/10 border border-amber/20 rounded-xl p-4 mb-8 inline-block" data-id="element-146">
                  <p className="text-navy font-medium" data-id="element-147">
                    Valor real:{' '}
                    <span className="line-through text-navy/50" data-id="element-148">
                      $13.00 USD
                    </span>{' '}
                    —{' '}
                    <span className="text-amber-dark font-bold" data-id="element-149">
                      Hoy: GRATIS
                    </span>
                  </p>
                </div>

                <p className="text-lg text-navy/80 mb-6 leading-relaxed" data-id="element-150">
                  ¿Cuántas veces fuiste a hablar con el colegio y saliste con un
                  "vamos a verlo" que no llevó a nada? Ese ciclo termina hoy.
                  Este bonus te da todo lo que necesitás para llegar preparado y
                  salir con compromisos concretos.
                </p>

                <ul className="space-y-3 mb-8" data-id="element-151">
                  <li className="flex items-start gap-3" data-id="element-152">
                    <Check className="text-teal flex-shrink-0 mt-1" size={20} data-id="element-153" />
                    <span className="text-navy/80" data-id="element-154">
                      <strong data-id="element-155">Preparación en 20 minutos</strong>: cómo escribir
                      tus 3 incidentes con fecha y lugar (sin emociones, con
                      hechos).
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-156">
                    <Check className="text-teal flex-shrink-0 mt-1" size={20} data-id="element-157" />
                    <span className="text-navy/80" data-id="element-158">
                      <strong data-id="element-159">Menú de medidas concretas</strong>: no vas a
                      "pedir ayuda" en general, vas a pedir acciones
                      específicas.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-160">
                    <Check className="text-teal flex-shrink-0 mt-1" size={20} data-id="element-161" />
                    <span className="text-navy/80" data-id="element-162">
                      <strong data-id="element-163">3 guiones según con quién hables</strong>:
                      Teacher, Counselor, o Principal.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-164">
                    <Check className="text-teal flex-shrink-0 mt-1" size={20} data-id="element-165" />
                    <span className="text-navy/80" data-id="element-166">
                      <strong data-id="element-167">Frases exactas en inglés</strong> (copy/paste) y{' '}
                      <strong data-id="element-168">Email recap</strong> para dejar todo por escrito.
                    </span>
                  </li>
                </ul>

                <div className="border-l-4 border-teal pl-6 py-2" data-id="element-169">
                  <p className="text-sm font-bold text-navy/60 uppercase tracking-wider mb-2" data-id="element-170">
                    La frase que cambia todo:
                  </p>
                  <p className="text-xl font-serif italic text-navy" data-id="element-171">
                    "I'm requesting a safety plan for my child starting
                    tomorrow."
                  </p>
                  <p className="text-navy/70 mt-2" data-id="element-172">
                    Una sola frase transforma la conversación de "problema de
                    patio" a protocolo de seguridad.
                  </p>
                </div>
              </div>

              <div className="order-1 lg:order-2 flex justify-center" data-id="element-173">
                <img src="https://cdn.magicpatterns.com/uploads/ceQKegU1prNSn3rVz4n17G/Bonu_3.png" alt="Reunión en 20 Min" className="w-full max-w-md rounded-2xl shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-174" />
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}